export default "__VITE_ASSET__DhxUfJCX__"